<template>
  <page>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-toolbar dense color="grey lighten-3" flat>
              <v-icon>mdi-magnify</v-icon>
              <v-toolbar-title>View Payment</v-toolbar-title>
            </v-toolbar>
            <v-tabs>
              <v-tab @click.native="doMandatory(0)">Mandatory</v-tab>
              <v-tab @click.native="doOptional(1)">Optional</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabNav">
              <v-tab-item transition="fade-transition" reverse-transition="fade-transition" key="mandatory">
                <form data-vv-scope="paymentMandatoryForm">
                  <v-flex xs12>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.branch }}</v-subheader>
                              <div class="queryValue" v-for="item in filterBranchList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md2 xs12 sm2 lg2>
                              <v-checkbox color="primary" :label="mulAcctPayLabel.docAE" v-model="mulAcctPayForm.docAE" disabled></v-checkbox>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.documentNo }}</v-subheader>
                              <div class="queryValue">{{ mulAcctPayForm.documentNo }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.transactionDate }}</v-subheader>
                              <div class="queryValue">{{ convertDate(mulAcctPayForm.transactionDate) }}</div>
                            </v-flex>
                            <v-flex md5 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.fromBank }}</v-subheader>
                              <div class="queryValue" v-for="item in filterFromBankList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md2 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.fund }}</v-subheader>
                              <div class="queryValue" v-for="item in filterFundList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md5 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.gstIO }}</v-subheader>
                              <div class="queryValue" v-for="item in filterGstIOList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.gstStatus }}</v-subheader>
                              <div class="queryValue" v-for="item in filterGstStatusList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md3 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.gstRate }}</v-subheader>
                              <div class="queryValue">{{ mulAcctPayForm.gstRate }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.payTo }}</v-subheader>
                              <div class="queryValue" v-for="item in filterPayToList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md5 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.accountNoSuffix }}</v-subheader>
                              <div class="queryValue" v-for="item in filterAccountNoSuffixList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.amountCurr }}</v-subheader>
                              <div class="queryValue" v-for="item in filterAmountCurrList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md8 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.amount }}</v-subheader>
                              <div class="queryValue">{{ mulAcctPayForm.amount }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.gstAmountCurr }}</v-subheader>
                              <div class="queryValue" v-for="item in filterGstAmountCurrList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md2 xs12 sm2 lg2>
                              <v-checkbox color="primary" :label="mulAcctPayLabel.gstAmountAE" disabled></v-checkbox>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.gstAmount }}</v-subheader>
                              <div class="queryValue">{{ mulAcctPayForm.gstAmount }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.netAmountCurr }}</v-subheader>
                              <div class="queryValue" v-for="item in filterNetAmountCurrList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md8 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.netAmount }}</v-subheader>
                              <div class="queryValue">{{ mulAcctPayForm.netAmount }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.bankAmountCurr }}</v-subheader>
                              <div class="queryValue">{{ filterCurrList(mulAcctPayForm.bankAmountCurr) }}</div>
                            </v-flex>
                            <v-flex md2 xs12 sm2 lg2>
                              <v-checkbox color="primary" :label="mulAcctPayLabel.bankAmountAE" disabled></v-checkbox>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.bankAmount }}</v-subheader>
                              <div class="queryValue">{{ mulAcctPayForm.bankAmount }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.bankChargesCurr }}</v-subheader>
                              <div class="queryValue">{{ filterCurrList(mulAcctPayForm.bankChargesCurr) }}</div>
                            </v-flex>
                            <v-flex md8 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.bankCharges }}</v-subheader>
                              <div class="queryValue">{{ mulAcctPayForm.bankCharges }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.bankTotalAmountCurr }}</v-subheader>
                              <div class="queryValue">{{ filterCurrList(mulAcctPayForm.bankTotalAmountCurr) }}</div>
                            </v-flex>
                            <v-flex md8 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.bankTotalAmount }}</v-subheader>
                              <div class="queryValue">{{ mulAcctPayForm.bankTotalAmount }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.bankTotalLocalCurr }}</v-subheader>
                              <div class="queryValue" v-for="item in filterBankTotalLocalCurrList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md2 xs12 sm2 lg2>
                              <v-checkbox
                                color="primary"
                                :label="mulAcctPayLabel.bankTotalLocalAE"
                                v-model="mulAcctPayForm.bankTotalLocalAE"
                                disabled
                              ></v-checkbox>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.bankTotalLocal }}</v-subheader>
                              <div class="queryValue">{{ mulAcctPayForm.bankTotalLocal }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm4 lg4>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.chequeNo }}</v-subheader>
                              <div class="queryValue">{{ mulAcctPayForm.chequeNo }}</div>
                            </v-flex>
                            <v-flex md8 xs12 sm8 lg8>
                              <v-checkbox color="primary" :label="mulAcctPayLabel.prtCheque" v-model="mulAcctPayForm.prtCheque" disabled></v-checkbox>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.createdBy }}</v-subheader>
                              <div class="queryValue">{{ mulAcctPayForm.createdBy + ' on ' + mulAcctPayForm.createdDate }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.modifiedBy }}</v-subheader>
                              <div class="queryValue">{{ mulAcctPayForm.modifiedBy + ' on ' + mulAcctPayForm.modifiedDate }}</div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </form>
              </v-tab-item>
              <v-tab-item transition="fade-transition" reverse-transition="fade-transition" key="optional">
                <form data-vv-scope="paymentOptionalForm">
                  <v-flex xs12>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex md12 xs12 sm12 lg12>
                              <div class="header-padding body-2">Document Details</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.printDocument }}</v-subheader>
                              <div class="queryValue" v-for="item in filterPrintDocumentList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.addressTo }}</v-subheader>
                              <div class="queryValue" v-for="item in filterAddressToList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md7 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.policyNo }}</v-subheader>
                              <div class="queryValue">{{ mulAcctPayForm.policyNo }}</div>
                            </v-flex>
                            <v-flex md7 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.companyName }}</v-subheader>
                              <div class="queryValue">{{ mulAcctPayForm.companyName }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.docAddress1 }}</v-subheader>
                              <div class="queryValue">{{ mulAcctPayForm.docAddress1 }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.docAddress2 }}</v-subheader>
                              <div class="queryValue">{{ mulAcctPayForm.docAddress2 }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.docAddress3 }}</v-subheader>
                              <div class="queryValue">{{ mulAcctPayForm.docAddress3 }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.docAddress4 }}</v-subheader>
                              <div class="queryValue">{{ mulAcctPayForm.docAddress4 }}</div>
                            </v-flex>
                            <v-flex md7 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.postalCode }}</v-subheader>
                              <div class="queryValue">{{ mulAcctPayForm.postalCode }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.details }}</v-subheader>
                              <div class="queryValue">{{ mulAcctPayForm.details }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.statementRef }}</v-subheader>
                              <div class="queryValue">{{ mulAcctPayForm.statementRef }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm12 lg12>
                              <div class="header-padding body-2">Other Details</div>
                            </v-flex>
                            <v-flex md7 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.department }}</v-subheader>
                              <div class="queryValue" v-for="item in filterDepartmentList" :key="item.label">{{ item.label }}</div>
                            </v-flex>
                            <v-flex md12 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.insuredName }}</v-subheader>
                              <div class="queryValue">{{ mulAcctPayForm.insuredName }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.claimNo }}</v-subheader>
                              <div class="queryValue">{{ mulAcctPayForm.claimNo }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.gstRegNo }}</v-subheader>
                              <div class="queryValue">{{ mulAcctPayForm.gstRegNo }}</div>
                            </v-flex>
                            <v-flex md4 xs12 sm6 lg6>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.taxInvoiceNo }}</v-subheader>
                              <div class="queryValue">{{ mulAcctPayForm.taxInvoiceNo }}</div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </form>
              </v-tab-item>
            </v-tabs-items>
            <v-flex xs12 class="mt-3">
              <v-card>
                <v-data-table
                  v-bind:headers="listMulAcctPayHeaders"
                  v-bind:items="accountList"
                  item-key="key"
                  :loading="loading"
                  :no-data-text="noDataText"
                >
                  <template v-slot:item="row"
                    ><tr>
                      <td v-for="column in selectAcctPayColumns" :key="column">{{ row.item[column] }}</td>
                      <td class="table-action-header">
                        <table-action :rowData="row" query @query="doQuery(row.item)"></table-action>
                      </td></tr
                  ></template>
                </v-data-table>
              </v-card>
            </v-flex>
            <v-flex xs12>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <h3><u>Grand Total </u></h3>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="grandTotForm.payment"
                          :label="grandTotLabel.payment"
                          disabled
                          :error-messages="errors.collect('grandTotForm.payment')"
                          data-vv-name="grandTotForm.payment"
                          :data-vv-as="grandTotLabel.payment"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="grandTotForm.gst"
                          :label="grandTotLabel.gst"
                          disabled
                          :error-messages="errors.collect('grandTotForm.gst')"
                          data-vv-name="grandTotForm.gst"
                          :data-vv-as="grandTotLabel.gst"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="grandTotForm.net"
                          :label="grandTotLabel.net"
                          disabled
                          :error-messages="errors.collect('grandTotForm.net')"
                          data-vv-name="grandTotForm.net"
                          :data-vv-as="grandTotLabel.net"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="grandTotForm.bankAmt"
                          :label="grandTotLabel.bankAmt"
                          disabled
                          :error-messages="errors.collect('grandTotForm.bankAmt')"
                          data-vv-name="grandTotForm.bankAmt"
                          :data-vv-as="grandTotLabel.bankAmt"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="grandTotForm.charges"
                          :label="grandTotLabel.charges"
                          disabled
                          :error-messages="errors.collect('grandTotForm.charges')"
                          data-vv-name="grandTotForm.charges"
                          :data-vv-as="grandTotLabel.charges"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="grandTotForm.total"
                          :label="grandTotLabel.total"
                          disabled
                          :error-messages="errors.collect('grandTotForm.total')"
                          data-vv-name="grandTotForm.total"
                          :data-vv-as="grandTotLabel.total"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="grandTotForm.localTotal"
                          :label="grandTotLabel.localTotal"
                          disabled
                          :error-messages="errors.collect('grandTotForm.localTotal')"
                          data-vv-name="grandTotForm.localTotal"
                          :data-vv-as="grandTotLabel.localTotal"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12>
              <v-btn color="error" dark @click.prevent="doCancel">
                {{ actionLabel.cancel }}
                <v-icon dark right>mdi-exit-to-app</v-icon>
              </v-btn>
            </v-flex>
          </v-card>
        </v-flex>
      </v-layout>
      <v-dialog v-model="processingFlag" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Processing...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="showErrorDialog" width="800px">
        <v-card>
          <v-card-title primary-title>
            <div>
              <div class="headline">System Information</div>
              <span class="grey--text">An error occurred when review payment.</span>
            </div>
          </v-card-title>
          <v-card-text>
            <div v-if="messages.length > 0" class="pb-3">
              <v-subheader>Error Details:</v-subheader>
              <ul class="showErrorMsgs">
                <li v-for="(error, index) in messages" :key="index">
                  {{ error.message }}
                </li>
              </ul>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </page>
</template>

<script>
import routeMixin from '@/mixins/route'
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { mulAcctPaymentAjaxMixin } from '@/mixins/accounting/payment/mulAcctPayt/mulAcctPaymentAjaxMixin'
import { mulAcctPaymentViewMixin } from '@/mixins/accounting/payment/mulAcctPayt/mulAcctPaymentViewMixin'
import { formatDisplayDate } from '@/utils/date'
import * as TableConst from '@/mixins/table'
import { formatPrice } from '@/utils/index'
import { removeFormatNumber } from '@/utils/number'

export default {
  data() {
    return {
      tabNav: 0,
      actionLabel: {
        cancel: 'Cancel'
      },
      miscacctparams: [],
      cashbooks: [],
      departments: [],
      loading: false,
      processingFlag: false,
      showErrorDialog: false,
      submitting: false,
      isMandatory: true,
      isOptional: false,
      accounts: [],
      accountdata: {},
      banks: [],
      funds: [],
      bankdata: {},
      acctnosuffixes: [],
      acctnosuffixdata: {},
      amountcurrencies: [],
      amountcurrencydata: {},
      gstStatuses: [],
      gstrate: '0.00',
      actionName: null,
      currencyrate: {},
      grandTotLabel: {
        payment: 'Payment',
        gst: 'GST',
        net: 'Net',
        bankAmt: 'Bank Amt',
        charges: 'Charges',
        total: 'Total',
        localTotal: 'Local Total'
      },
      grandTotForm: {
        payment: '0.00',
        gst: '0.00',
        net: '0.00',
        bankAmt: '0.00',
        charges: '0.00',
        total: '0.00',
        localTotal: '0.00'
      },
      validStatus: {
        mandatory: true,
        optional: true
      }
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('paymentInit')])
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.getCommonData('miscacctparams', 'cash')
      this.getCommonData('miscacctparams').then(() => {
        this.mulAcctPayForm.printDocument = this.miscacctparams.defIlnrcpt
      })
      this.fetchBranch()
      this.fetchFund()
      this.fetchCurrency()
      this.fetchCashBook()
      this.fetchDepartment()
      this.fetchAccount()
      this.fetchBank()
      this.fetchAcctNoSfx()
      this.fetchAmountCurrency()
      this.fetchGstStatus()
      await Promise.all([this.performReviewMultAcctPayt()])
    },
    filterCurrList(curr) {
      const data = this.currencies.find(list => list.value === curr)
      return data ? data.label : ''
    },
    convertDate(date) {
      if (date !== null) {
        return formatDisplayDate(date)
      }
    },
    doMandatory(tabId) {
      if (this.isMandatory === false) {
        this.isMandatory = true
        this.isOptional = false
        this.validStatus.optional = true
        this.validStatus.mandatory = true
        this.tabNav = tabId
      }
    },
    doOptional(tabId) {
      if (this.isOptional === false) {
        this.isMandatory = false
        this.isOptional = true
        this.validStatus.mandatory = true
        this.validStatus.optional = true
        this.tabNav = tabId
      }
    },
    async doQuery(data) {
      this.mulAcctPayForm.branch = data.branch
      this.mulAcctPayForm.accountNo = data.accountNo
      this.mulAcctPayForm.documentNo = data.documentNo
      this.mulAcctPayForm.transactionType = data.transactionType
      this.mulAcctPayForm.docAE = data.docAE === 'true' || data.docAE === true
      this.mulAcctPayForm.transactionDate = data.transactionDate
      this.mulAcctPayForm.payTo = data.payTo
      this.mulAcctPayForm.bankNo = data.bankNo
      this.mulAcctPayForm.fromBank = data.fromBank
      this.mulAcctPayForm.fund = data.fund
      this.mulAcctPayForm.accountNoSuffix = data.accountNoSuffix
      this.mulAcctPayForm.cashBook = data.cashBook
      this.mulAcctPayForm.gstIO = data.gstIO
      this.mulAcctPayForm.gstStatus = data.gstStatus
      this.mulAcctPayForm.gstRate = data.gstRate
      this.mulAcctPayForm.amountCurr = data.amountCurr
      this.mulAcctPayForm.amount = data.amount
      this.mulAcctPayForm.gstAmountCurr = data.gstAmountCurr
      this.mulAcctPayForm.amountCurrRate = data.amountCurrRate
      this.mulAcctPayForm.gstAmountAE = data.gstAmountAE === 'A'
      this.mulAcctPayForm.gstAmount = data.gstAmount
      this.mulAcctPayForm.netAmountCurr = data.netAmountCurr
      this.mulAcctPayForm.netAmount = data.netAmount
      this.mulAcctPayForm.bankAmountCurr = data.bankAmountCurr
      this.mulAcctPayForm.bankAmountAE = data.bankAmountAE === 'A'
      this.mulAcctPayForm.bankAmount = data.bankAmount
      this.mulAcctPayForm.bankAmountCurrRate = data.bankAmountCurrRate
      this.mulAcctPayForm.bankChargesCurr = data.bankChargesCurr
      this.mulAcctPayForm.bankCharges = data.bankCharges
      this.mulAcctPayForm.bankTotalAmountCurr = data.bankTotalAmountCurr
      this.mulAcctPayForm.bankTotalAmount = data.bankTotalAmount
      this.mulAcctPayForm.bankTotalLocalCurr = data.bankTotalLocalCurr
      this.mulAcctPayForm.bankTotalLocalAE = data.bankTotalLocalAE === 'A'
      this.mulAcctPayForm.bankTotalLocal = data.bankTotalLocal
      this.mulAcctPayForm.bankTotalLocalCurrRate = data.bankTotalLocalCurrRate
      this.mulAcctPayForm.chequeNo = data.chequeNo
      this.mulAcctPayForm.prtCheque = data.prtCheque
      this.mulAcctPayForm.isDeptMand = data.isDeptMand
      this.mulAcctPayForm.printDocument = data.printDocument
      this.mulAcctPayForm.addressTo = data.addressTo
      this.mulAcctPayForm.policyNo = data.policyNo
      this.mulAcctPayForm.companyName = data.companyName
      this.mulAcctPayForm.docAddress1 = data.docAddress1
      this.mulAcctPayForm.docAddress2 = data.docAddress2
      this.mulAcctPayForm.docAddress3 = data.docAddress3
      this.mulAcctPayForm.docAddress4 = data.docAddress4
      this.mulAcctPayForm.postalCode = data.postalCode
      this.mulAcctPayForm.details = data.details
      this.mulAcctPayForm.statementRef = data.statementRef
      this.mulAcctPayForm.department = data.department
      this.mulAcctPayForm.insuredName = data.insuredName
      this.mulAcctPayForm.claimNo = data.claimNo
      this.mulAcctPayForm.gstRegNo = data.gstRegNo
      this.mulAcctPayForm.taxInvoiceNo = data.taxInvoiceNo
      this.mulAcctPayForm.isExistDocNo = data.isExistDocNo
      this.mulAcctPayForm.oldFund = data.oldFund
      this.mulAcctPayForm.oldAccountNoSuffix = data.oldAccountNoSuffix
      this.mulAcctPayForm.createdBy = await this.fetchUserDetails(data.createdBy)
      this.mulAcctPayForm.createdDate = data.createdDate
      this.mulAcctPayForm.modifiedBy = await this.fetchUserDetails(data.modifiedBy)
      this.mulAcctPayForm.modifiedDate = data.modifiedDate
    },
    doCancel() {
      this.$router.push({ name: 'mulAcctPayment' }).catch(() => {})
    },
    doAccumulate() {
      this.grandTotForm.payment = '0.00'
      this.grandTotForm.gst = '0.00'
      this.grandTotForm.net = '0.00'
      this.grandTotForm.bankAmt = '0.00'
      this.grandTotForm.charges = '0.00'
      this.grandTotForm.total = '0.00'
      this.grandTotForm.localTotal = '0.00'

      for (var i = 0; i < this.accountList.length; i++) {
        this.grandTotForm.payment = formatPrice(
          Number(removeFormatNumber(this.grandTotForm.payment)) + Number(removeFormatNumber(this.accountList[i].amount))
        )
        this.grandTotForm.gst = formatPrice(
          Number(removeFormatNumber(this.grandTotForm.gst)) + Number(removeFormatNumber(this.accountList[i].gstAmount))
        )
        this.grandTotForm.net = formatPrice(
          Number(removeFormatNumber(this.grandTotForm.net)) + Number(removeFormatNumber(this.accountList[i].netAmount))
        )
        this.grandTotForm.bankAmt = formatPrice(
          Number(removeFormatNumber(this.grandTotForm.bankAmt)) + Number(removeFormatNumber(this.accountList[i].bankAmount))
        )
        this.grandTotForm.charges = formatPrice(
          Number(removeFormatNumber(this.grandTotForm.charges)) + Number(removeFormatNumber(this.accountList[i].bankCharges))
        )
        this.grandTotForm.total = formatPrice(
          Number(removeFormatNumber(this.grandTotForm.total)) + Number(removeFormatNumber(this.accountList[i].bankTotalAmount))
        )
        this.grandTotForm.localTotal = formatPrice(
          Number(removeFormatNumber(this.grandTotForm.localTotal)) + Number(removeFormatNumber(this.accountList[i].bankTotalLocal))
        )
      }
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  computed: {
    paymentData() {
      return this.$store.state.payment.paymentData
    },
    listMulAcctPayHeaders() {
      let result = []
      for (const selectAcctPayColumns of this.selectAcctPayColumns) {
        let findCol = this.mulAcctPayColumns.find((a) => selectAcctPayColumns === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    filterBranchList() {
      return this.branches.filter((list) => {
        return list.value === this.mulAcctPayForm.branch
      })
    },
    filterPayToList() {
      return this.accounts.filter((list) => {
        return list.value === this.mulAcctPayForm.payTo
      })
    },
    filterFromBankList() {
      return this.banks.filter((list) => {
        return list.value === this.mulAcctPayForm.fromBank
      })
    },
    filterAccountNoSuffixList() {
      return this.acctnosuffixes.filter((list) => {
        return list.value === this.mulAcctPayForm.accountNoSuffix
      })
    },
    filterGstIOList() {
      return this.gstIO.filter((list) => {
        return list.value === this.mulAcctPayForm.gstIO
      })
    },
    filterGstStatusList() {
      return this.gstStatuses.filter((list) => {
        return list.value === this.mulAcctPayForm.gstStatus
      })
    },
    filterAmountCurrList() {
      return this.amountcurrencies.filter((list) => {
        return list.value === this.mulAcctPayForm.amountCurr
      })
    },
    filterGstAmountCurrList() {
      return this.currencies.filter((list) => {
        return list.value === this.mulAcctPayForm.gstAmountCurr
      })
    },
    filterNetAmountCurrList() {
      return this.currencies.filter((list) => {
        return list.value === this.mulAcctPayForm.netAmountCurr
      })
    },
    filterBankTotalLocalCurrList() {
      return this.currencies.filter((list) => {
        return list.value === this.mulAcctPayForm.bankTotalLocalCurr
      })
    },
    filterPrintDocumentList() {
      return this.printDocOpts.filter((list) => {
        return list.value === this.mulAcctPayForm.printDocument
      })
    },
    filterAddressToList() {
      return this.addressToOpts.filter((list) => {
        return list.value === this.mulAcctPayForm.addressTo
      })
    },
    filterDepartmentList() {
      return this.departments.filter((list) => {
        return list.value === this.mulAcctPayForm.department
      })
    },
    filterFundList() {
      return this.funds.filter((list) => {
        return list.value === this.mulAcctPayForm.fund
      })
    }
  },
  mounted() {
    this.doInit()
  },
  mixins: [routeMixin, MessageMixin, TableConst.default, commonAjaxMixin, mulAcctPaymentAjaxMixin, mulAcctPaymentViewMixin]
}
</script>
<style lang="scss">
@import '../../../../../assets/scss/accounting.scss';
</style>
